import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {createEntityAdapter, createSelector, EntityState} from "@reduxjs/toolkit";
import {ApiKeyCreate, ApiKeyCreateResponse, ApiKeyRead} from "../Models/models";
import {store} from "./store";
import appConfig from "../Config/config";
import {keycloak} from "../Config/keycloak"


const apiKeyAdapter = createEntityAdapter({
    selectId: (item: ApiKeyRead) => item.apiKeyId,
    sortComparer: (a: ApiKeyRead, b: ApiKeyRead) => a.apiKeyId.localeCompare(b.apiKeyId)
})

const initialStateApiKeys = apiKeyAdapter.getInitialState()


export const apiKeyManagementApi = createApi({
    reducerPath: 'apiKeyManagementApi',
    baseQuery: fetchBaseQuery({
        baseUrl: appConfig.backendApiUrl + '/v1/keys',
        prepareHeaders: async (headers) => {
            if (keycloak.token) {
                headers.set('Authorization', `Bearer ${keycloak.token}`)
            }
            return headers
        }
    }),
    tagTypes: ['apiKeys'],
    endpoints: (builder) => ({
        getApiKeys: builder.query<EntityState<ApiKeyRead, any>, void>({
            query: () => ({
                url: '/api-keys'
            }),
            providesTags: (result) =>
                result && result.ids.length > 0
                    ? [...result.ids.map((apiKeyId)=> ({type: 'apiKeys', id: apiKeyId} as const)), {type: 'apiKeys', id: 'LIST'}]
                    : [{type: 'apiKeys', id: 'LIST'}],
            transformResponse: (response: [ApiKeyRead]) =>
                apiKeyAdapter.setAll(initialStateApiKeys, response)
        }),
        addApiKey: builder.mutation<ApiKeyCreateResponse, ApiKeyCreate>({
            query: (data) => ({
                url: '/api-keys',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{type: 'apiKeys', id: 'LIST'}]
        }),
        deleteApiKey: builder.mutation<string, ApiKeyRead['apiKeyId']>({
            query: (apiKeyId) => ({
                url: `/api-keys/${apiKeyId}`,
                method: 'DELETE'
            }),
            invalidatesTags: [{type: 'apiKeys', id: 'LIST'}]
        })
    }),
})

const {useGetApiKeysQuery, useAddApiKeyMutation, useDeleteApiKeyMutation} = apiKeyManagementApi

type RootState = ReturnType<typeof store.getState>

const selectApiKeyResult = apiKeyManagementApi.endpoints.getApiKeys.select()

const selectApiKeyData = createSelector(selectApiKeyResult, (result) => result.data)

const {selectAll} = apiKeyAdapter.getSelectors<RootState>((state) => {
    return selectApiKeyData(state) ?? initialStateApiKeys
})

export {selectAll as selectAllApiKeys,
    useGetApiKeysQuery,
    useAddApiKeyMutation,
    useDeleteApiKeyMutation
}

